import React, { FC, useContext, useEffect, useState } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { ParserContext } from '../contexts/ParserContext';
import { getParser, IParser } from '../../../shared/parsers/factory';
import Annotation from './Annotation';
import { AppDispatch } from '../../../store';
import { resetAllAnnotationManagerStates } from './annotation.slice';
import { connect } from 'react-redux';
import { User } from 'oidc-client';
import UserDetailsContext from '../../../Context/userDetails.context';
import { Permissions } from '../../../shared/models/permissions.enum';
import { useRequireAuth } from '../../../Auth/useRequireAuth';

type Props = RouteComponentProps<{ parser: string }>;

const ParserMiddleware: FC<
  Props & {
    clearStates: () => void;
  }
> = props => {
  const { match, clearStates } = props;
  const [parser, setParser] = useState<IParser<any>>();
  const [redirectToRoot, setRedirectToRoot] = useState(false);

  const { user } = useContext<{ user: User | null }>(UserDetailsContext);

  const auth = useRequireAuth(props, [Permissions.AnnotationManager_View]);

  useEffect(() => {
    return () => {
      clearStates();
    };
  }, [clearStates]);

  useEffect(() => {
    if (match.params.parser && !parser) {
      const newParser = getParser(match.params.parser);
      setParser(newParser);
      if (!newParser) {
        setRedirectToRoot(true);
      }
    }
  }, [match.params.parser, parser]);

  if (redirectToRoot) {
    return <Redirect to='/annotation-manager'></Redirect>;
  }

  if (!parser || !user || !auth) {
    return <div>Loading...</div>;
  }

  return (
    <ParserContext.Provider value={{ parser }}>
      <Switch>
        <Route path={`${match.path}/${parser.requiredPath}/${parser.optionalPath}`} component={Annotation} />
        <Redirect to='/annotation-manager'></Redirect>
      </Switch>
    </ParserContext.Provider>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  clearStates: () => dispatch(resetAllAnnotationManagerStates())
});

export default connect(null, mapDispatchToProps)(ParserMiddleware);
